<template>
  <div class="about">
    <div><p style="text-align: right;">{{shop}}</p></div>
    <h1>Find out if we’re right for you</h1>
    <p>
      The best way to get started using <strong>Connected Inventory</strong> is to follow our <a target="_blank" href="https://www.notion.so/inscoder/Quick-Start-Guide-3ff406ec859d4a2b8baeff1655ddea00">Quick Start Guide</a>
    </p>
    <p>
      If you are hae query, we will help you to find out if we’re right for you and working hand-in-hand with you to guide you with the setup.
    </p>
    <p>
      Send us an email and let’s see if we’re a fit
      <br>
      <a>support@inscoder.com</a>
    </p>

    <section>
      <v-card>
        <v-card-text>
          <h3>Update on 5 Nov 2022</h3>
          <div>1. You can now search the group name in Smart/Manual/Bundle group listing page.</div>
          <br>
        </v-card-text>
      </v-card>
      <v-card>
        <v-card-text>
          <h3>Update on 5 Jun 2022</h3>
          <div>1. The user interface of the bulk editor was updated. Please check out the video or <a target="_blank" href="https://www.notion.so/inscoder/More-FAQs-d90053e5ac194b9999d748b59db8dd1a#0269721bd4aa4ab29e57420a73e20ae9">faq</a> on how to show your store's location</div>
          <br>
        </v-card-text>
      </v-card>
    </section>

    <br>
    <h1>Get Started</h1>
    <section>
      <div class="faq-container">
        <div class="question">
          <h4>Setup Guide, FAQ and use cases</h4>
          <div class="content"><a target="_blank" href="https://www.notion.so/inscoder/Connected-Inventory-Help-Center-b9f6f01d950b4a5288f1997df350c874">Browse our support portal</a></div>
        </div>
      </div>
    </section>
    <section>
      <div class="faq-container">
        <div class="question">
          <h4>Step 1 - Read our Quick Start Guide</h4><br>
          <div class="content">Read the <strong><a target="_blank" href="https://www.notion.so/inscoder/Quick-Start-Guide-3ff406ec859d4a2b8baeff1655ddea00">Quick Start Guide</a></strong></div>
        </div>
      </div>
    </section>
    <section>
      <div class="faq-container">
        <div class="question">
          <h4>Step 2 - Explore the real case studies</h4><br>
          <div class="content"><strong><a target="_blank" href="https://www.notion.so/inscoder/Case-Studies-Bundles-and-Sets-1dee03fb2f04424aa595ac18f5fed27a">Bundle</a></strong></div>
          <div class="content"><strong><a target="_blank" href="https://www.notion.so/inscoder/Case-Studies-Inventory-Groups-0245b1f0921b43f493298431d9391c93">Smart group or Manual group</a></strong></div>
        </div>
      </div>
    </section>
    <section>
      <div class="faq-container">
        <div class="question">
          <h4>Step 3 - Click one of the options at the side menu to begin setting up inventory groups</h4><br>
          <div class="content">Use <strong><a target="_blank" href="https://www.notion.so/inscoder/Create-Bundles-and-Sets-564b5411f71c459985fc85257194804e">Bundle Groups</a></strong> if you are selling bundles / kits. Ex: Sold 1 Camera Kit should decrease 1 camera, 2 lens, and 1 tripod.</div><br>
          <div class="content">Use <strong><a target="_blank" href="https://www.notion.so/inscoder/Create-Inventory-Groups-Automatically-by-SKU-field-01558108a6034acea0fa3d9049c17a38">Smart Connected Groups by SKU</a></strong> if you need a base inventory quantity to share among many product; and prefers the app to automatically scan and create groups for you.</div><br>
          <div class="content">Use <strong><a target="_blank" href="https://www.notion.so/inscoder/Create-Inventory-Groups-Manually-96fd82585e2b4447843e7a658de5cdee"> Manual Connected Groups</a></strong> if you need a base inventory quantity to share among a smaller group of products; and prefers to create the groups by yourself to gain maximum grouping flexibility.</div>
        </div>
      </div>
    </section>
    <section>
      <div class="faq-container">
        <div class="question">
          <h4>Contact Us</h4>
          <div class="content">If you have any query, please contact us at <a href="mailto:support@inscoder.com">support@inscoder.com</a></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  computed: {
    count () {
      return this.$store.state.count
    }
  },
  created: function () {

  },
  data () {
    return {
      shop: this.$store.state.shop,
      info: null,
      loading: true,
    }
  },
  filters: {
    currencydecimal (value) {
      return value.toFixed(2)
    }
  },
  mounted () {

  }

}
</script>
